import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PronunciationService } from "@/services/agent/core";
import { PronunciationPair, Agent } from "@/types/agent/agent";

interface UsePronunciationsPayload {
  genie: Agent;
  pronunciations: PronunciationPair[];
}

export const usePronunciations = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ genie, pronunciations }: UsePronunciationsPayload) => {
      return PronunciationService.update(genie, pronunciations);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["agent"] });
      queryClient.invalidateQueries({ queryKey: ["agents"] });
      queryClient.invalidateQueries({ queryKey: ["user-agents"] });
      queryClient.invalidateQueries({ queryKey: ["all-agents"] });
    },
  });
};
